"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EStatus = exports.EPaymentFrequency = exports.EType = void 0;
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
const Office_1 = __importDefault(require("./Office"));
const class_validator_1 = require("class-validator");
const Seat_1 = __importDefault(require("./Seat"));
class Subscription extends Resource_1.default {
}
exports.default = Subscription;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Subscription.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Subscription.prototype, "stripe_subscription_id", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Subscription.prototype, "status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({
        groups: ["createSubscription"],
        message: "type is required",
    }),
    __metadata("design:type", String)
], Subscription.prototype, "type", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Date)
], Subscription.prototype, "start_date", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Date)
], Subscription.prototype, "end_date", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Number)
], Subscription.prototype, "nb_seats", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Office_1.default),
    (0, class_validator_1.IsNotEmpty)({
        groups: ["createSubscription"],
        message: "office is required",
    }),
    __metadata("design:type", Office_1.default)
], Subscription.prototype, "office", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Seat_1.default),
    __metadata("design:type", Array)
], Subscription.prototype, "seats", void 0);
var EType;
(function (EType) {
    EType["Standard"] = "STANDARD";
    EType["Unlimited"] = "UNLIMITED";
})(EType || (exports.EType = EType = {}));
var EPaymentFrequency;
(function (EPaymentFrequency) {
    EPaymentFrequency["Monthly"] = "MONTHLY";
    EPaymentFrequency["Yearly"] = "YEARLY";
})(EPaymentFrequency || (exports.EPaymentFrequency = EPaymentFrequency = {}));
var EStatus;
(function (EStatus) {
    EStatus["Active"] = "ACTIVE";
    EStatus["Inactive"] = "INACTIVE";
})(EStatus || (exports.EStatus = EStatus = {}));
